<div class="w-full">
  @switch (dataType) {
    @case ('TEXT') {
      <precredit-input
        [label]="label + (isRequired() ? ' *' : '')"
        [control]="control!"
        [placeholder]="placeholder"
        type="text"
      ></precredit-input>
    }

    @case ('NUMBER') {
      <precredit-input
        [label]="label + (isRequired() ? ' *' : '')"
        [control]="control!"
        [placeholder]="placeholder"
        type="number"
        (keydown)="preventEKey($event)"
      ></precredit-input>
    }

    @case ('LIST') {
      <div [formGroup]="getFormGroup()">
        <app-selector
          [label]="label + (isRequired() ? ' *' : '')"
          [placeholder]="placeholder"
          [optionsInput]="options"
          [size]="'medium'"
          [isOverlay]="useOverlayForList"
          [formControlName]="getControlName()"
        ></app-selector>
      </div>
    }

    @case ('DATE') {
      <input-date
        [label]="label + (isRequired() ? ' *' : '')"
        [control]="control!"
        [placeholder]="placeholder"
      ></input-date>
    }

    @case ('BOOLEAN') {
      <div [formGroup]="getFormGroup()">
        <div class="h-[70px] w-full flex items-center rounded-2xl" 
             [ngClass]="control?.invalid && control?.touched ? 'border-2 border-negative p-3' : ''"
             (click)="onCheckboxClick()">
          <app-checkbox
            [label]="label"
            customClass="w-full"
            [formControlName]="getControlName()"
            (change)="onCheckboxChange()"
          >
            <div class="flex flex-col items-start p-0 gap-1 flex-grow">
              <div class="flex flex-col items-start p-0 w-full">
                <label class="font-medium text-sm leading-5 text-text-secondary cursor-pointer w-full">
                  {{ label }}{{ isRequired() ? ' *' : '' }}
                </label>
              </div>
            </div>
          </app-checkbox>
        </div>
        @if (control?.invalid && checkBoxTouched) {
          <div class="flex items-center ml-3 mt-1">
            <i class="fi fi-sr-triangle-warning text-negative mr-1 text-[13px] flex-shrink-0 h-4 flex"></i>
            <p class="font-poppins font-normal text-[12px] text-start leading-tight text-[#B1000F]">
              {{ control?.errors | formError }}
            </p>
          </div>
        }
      </div>
    }

    @case ('TEXTAREA') {
      <precredit-input
        [control]="control!"
        [label]="label"
        [placeholder]="placeholder"
        type="textarea"
      ></precredit-input>
    }

  }
</div>
